import { render } from "./GalleryPicker.vue?vue&type=template&id=c7671fda&scoped=true"
import script from "./GalleryPicker.vue?vue&type=script&lang=js"
export * from "./GalleryPicker.vue?vue&type=script&lang=js"

import "./GalleryPicker.vue?vue&type=style&index=0&id=c7671fda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7671fda"]])

export default __exports__